import PropTypes from 'prop-types';

import { tidyHTML } from '@frolight/utils/utils';

import icons from '@frolight/assets/icons';

const Icon = ({ name, label, size = 'm', status = 'normal', className='' }) => {
  let classNames = 'icon';

  switch (size) {
    case 's':
      classNames += '  icon--small';
      break;
    case 'l':
      classNames += '  icon--large';
      break;
    default:
      break;
  }

  switch (status) {
    case 'error':
      classNames += '  icon--error';
      break;
    case 'warning':
      classNames += '  icon--warning';
      break;
    case 'success':
      classNames += '  icon--success';
      break;
    case 'disabled':
      classNames += '  icon--disabled';
      break;
    default:
      break;
  }

  return (
    <figure className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={classNames}
        dangerouslySetInnerHTML={{ 
          __html: `<title>${label}</title>${tidyHTML(icons.find((icon) => icon.name === name.trim()).svg)}`
        }}
      >
      </svg>
    </figure>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
}

export default Icon;
